import { FaFacebook } from "react-icons/fa";

export const Footer = () => {
    return (
        <footer className="bg-success text-white py-3 text-sm mb-0">
            <div className="container position-relative d-flex justify-content-center align-items-center">
                <span>Copyright © 2025 Youth Programme. All Rights Reserved.</span>
                {/* <a
                    href="https://www.facebook.com/pmlaptopupdates"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white d-flex align-items-center gap-2 text-decoration-none position-absolute end-0"
                >
                    <FaFacebook size={20} />
                    <span className="d-none d-md-inline">Facebook</span>
                </a> */}
            </div>
        </footer>
    )
};